export default "__VITE_ASSET__DKvaRvrI__"